import React from "react";
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    close: {
      padding: theme.spacing(0.5),
      cursor: "pointer"
    },
  }));

  
const SnackbarToast = ({showToast, setShowToast}) => {
  const {status, msg} = showToast;

  const handleClose = () => {
      setShowToast({status:false,msg:""})
    };
    const classes = useStyles();

    return (
        <>
        <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
        autoHideDuration={"2500"}
        open={status}
        onClose={handleClose}
        message={msg}
        action={
          <React.Fragment>
            <IconButton
              aria-label="close"
              color="inherit"
              className={classes.close}
              onClick={handleClose}
            >
              <CloseIcon />
            </IconButton>
          </React.Fragment>
        }
          >
  </Snackbar>
        </>
    )
}

export default SnackbarToast;